import { Swiper, SwiperSlide } from "swiper/react";
import { useState } from "react";

import "swiper/css";

/**
 * pc images swiper component
 * @param images images data
 * @param activeIndex active eq
 * @param handleMouseEnter swiper slide mouse enter event
 */
const PcSwiper = ({
  images,
  activeIndex,
  handleMouseEnter,
}: {
  images: string[];
  activeIndex: number;
  handleMouseEnter: (url: string, index: number) => void;
}) => {
  const [swiper, setSwiperInstance] = useState<any>(undefined);

  // slide change event
  const onSlideChange = (activeIndex: number) => {
    // console.log(activeIndex);
  };

  /**
   * swiper slide click event
   * @param index
   */
  const onSwiperClick = (index: number) => {
    if (!swiper) return;
    swiper.slideTo(index);
  };

  return (
    <>
      <div className="mt-5">
        <Swiper
          slidesPerView={4}
          spaceBetween={10}
          slideToClickedSlide={false}
          className="goods-detail-swiper"
          onSlideChange={(swiper) => {
            onSlideChange(swiper.activeIndex);
          }}
          onSwiper={(swiper) => setSwiperInstance(swiper)}
        >
          {images.map((url, index) => (
            <SwiperSlide key={index}>
              <div
                className={`goods-swiper-slide ${
                  activeIndex === index ? "active" : ""
                }`}
                onMouseEnter={() => {
                  handleMouseEnter(url, index);
                }}
                onClick={() => {
                  onSwiperClick(index);
                }}
              >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={url} alt=""/>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <style jsx global>
        {`
          .goods-detail-swiper .goods-swiper-slide {
            height: 110px;
            background: #f6f6f6;
            border: 1px solid #ddd;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .goods-detail-swiper .goods-swiper-slide img {
            max-height: 100%;
            max-width: 100%;
          }

          // .goods-detail-swiper .swiper-slide-active .goods-swiper-slide {
          //   border-color: #757575;
          // }

          .goods-detail-swiper .goods-swiper-slide.active {
            border-color: #757575;
          }
        `}
      </style>
    </>
  );
};

export default PcSwiper;
